import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {UmpirePushNotification} from '@tisa-group/models';

@Injectable()
export class PushNotificationService implements CrudService<UmpirePushNotification> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpirePushNotification[]>> {
    return this.http
      .get(`/push_notifications`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/push_notifications/${id}`);
  }

  create(
    body: Partial<UmpirePushNotification>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePushNotification>> {
    return this.http
      .post<JsonApiResponse<UmpirePushNotification>>(
        '/push_notifications',
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePushNotification>> {
    return this.http
      .get(`/push_notifications/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpirePushNotification>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePushNotification>> {
    return this.http
      .patch<JsonApiResponse<UmpirePushNotification>>(
        `/push_notifications/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
